export class ColorMetricModel {
  val!: number;
  ver!: number;
}

export default class ColorMetric extends ColorMetricModel {
  constructor({ val, ver }: ColorMetricModel) {
    super();

    this.val = val;
    this.ver = ver;
  }
}
